/* Bhairav Tatva v5 — compact header dropdown, gemstone tile toggle limits. Loads after bt-v3.js.
   The dropdown card lives at the end of <body> (built from the <template> in snippets/bt-dd.liquid),
   so Horizon's header hydration/morphing can never swap the old mega menu back in. */
(() => {
  const path = (u) => { try { return new URL(u, location.href).pathname.replace(/\/$/, ''); } catch (e) { return u; } };
  const pops = [];
  let cur = null;   // menu item the open card belongs to
  let open = null;  // open card
  let timer;

  const liFor = (el) => {
    const li = el && el.closest ? el.closest('header-menu .menu-list__list-item') : null;
    return li && !li.getAttribute('slot') ? li : null;
  };
  const popFor = (li) => {
    const a = li.querySelector('.menu-list__link');
    return a ? pops.find((p) => p.dataset.path === path(a.href)) : null;
  };

  const place = (li, pop) => {
    const r = li.getBoundingClientRect();
    const row = li.closest('.header__row') || li;
    const bottom = row.getBoundingClientRect().bottom;
    const w = pop.offsetWidth;
    let left = r.left + r.width / 2 - w / 2;
    left = Math.max(16, Math.min(left, document.documentElement.clientWidth - 16 - w));
    pop.style.left = `${Math.round(left + window.scrollX)}px`;
    pop.style.top = `${Math.round(bottom + window.scrollY)}px`;
  };
  const show = (li, pop) => {
    clearTimeout(timer);
    if (open && open !== pop) hide();
    place(li, pop);
    pop.classList.add('is-open');
    li.classList.add('bt-dd-on');
    open = pop; cur = li;
  };
  const hide = () => {
    clearTimeout(timer);
    if (open) open.classList.remove('is-open');
    if (cur) cur.classList.remove('bt-dd-on');
    open = null; cur = null;
  };
  const hideSoon = () => { clearTimeout(timer); timer = setTimeout(hide, 180); };

  const build = () => document.querySelectorAll('template[data-bt-dd]').forEach((t) => {
    if (t.dataset.built) return;
    t.dataset.built = '1';
    const pop = document.createElement('div');
    pop.className = 'bt-ddp';
    pop.dataset.path = path(t.dataset.btDd);
    pop.append(t.content.firstElementChild.cloneNode(true));
    pop.addEventListener('pointerenter', () => clearTimeout(timer));
    pop.addEventListener('pointerleave', (e) => { if (!(cur && cur.contains(e.relatedTarget))) hideSoon(); });
    pop.addEventListener('focusout', (e) => { if (!pop.contains(e.relatedTarget) && !(cur && cur.contains(e.relatedTarget))) hideSoon(); });
    document.body.append(pop);
    pops.push(pop);
  });

  const desktop = window.matchMedia('(min-width: 750px)');
  document.addEventListener('pointerover', (e) => {
    if (e.pointerType === 'touch' || !desktop.matches) return;
    const li = liFor(e.target);
    if (!li) return;
    const pop = popFor(li);
    if (pop) show(li, pop); else if (open) hide();
  });
  document.addEventListener('pointerout', (e) => {
    const li = liFor(e.target);
    if (!li || li !== cur) return;
    const to = e.relatedTarget;
    if (to && (li.contains(to) || (open && open.contains(to)))) return;
    hideSoon();
  });
  document.addEventListener('focusin', (e) => {
    if (!desktop.matches) return;
    const li = liFor(e.target);
    if (li) { const pop = popFor(li); if (pop) show(li, pop); else if (open) hide(); return; }
    if (open && !open.contains(e.target)) hide();
  });
  // The chevron next to the link toggles the card (keyboard and touch laptops).
  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('.menu-list__disclosure');
    const li = btn && liFor(btn);
    const pop = li && popFor(li);
    if (!pop) return;
    if (open === pop) hide(); else { show(li, pop); const first = pop.querySelector('a'); if (first && e.detail === 0) first.focus(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !open) return;
    const li = cur; hide();
    const a = li && li.querySelector('.menu-list__link'); if (a) a.focus();
  });
  window.addEventListener('scroll', () => { if (open) hide(); }, { passive: true });
  window.addEventListener('resize', () => { if (open) hide(); });

  // Gemstone tiles: 9 on phones (3 × 3), 12 on the collection page on desktop.
  const mq = window.matchMedia('(max-width: 749px)');
  const tidy = () => document.querySelectorAll('[data-gcats-toggle]').forEach((b) => {
    const list = b.previousElementSibling;
    if (!list) return;
    const n = list.children.length;
    const limit = mq.matches ? 9 : (list.classList.contains('bt-gcats--compact') ? 12 : Infinity);
    b.hidden = n <= limit;
  });
  mq.addEventListener?.('change', tidy);

  const init = () => { build(); tidy(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
